/**
 * Provides a gui for uploading images in bulk.
 * @module gui/pages/images-upload-bulk
 */
import React from 'react'
import { start as startApp } from '..'
import HomePage from '../../components/home-page'

/**
 * Entry point for the home page
 */
async function start () {
  const children = <HomePage />
  await startApp({
    children,
  })
}

if (!module.parent) {
  start()
}
